import styled from 'styled-components';

/**
 * The hover treatment used by the picker cards (Graphics > Overlays, template
 * and composition grids): the card dims and a glass action button appears
 * centred on it. Render inside a `position: relative` card.
 *
 * The dim inherits the card's corner radius, so it fits whatever card hosts it.
 */
export default function GlassHoverOverlay({ label }: { label: string }) {
  return (
    <>
      <GlassDimOverlay />
      <GlassButtonWrapper>
        <GlassButton>{label}</GlassButton>
      </GlassButtonWrapper>
    </>
  );
}

export const GlassDimOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.56);
  border-radius: inherit;
  z-index: 2;
  pointer-events: none;
`;

export const GlassButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  gap: 6px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
`;

export const GlassButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  white-space: nowrap;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-normal) ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;
